import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import processvideo from "../../../../assets/icons/Obsessionsgiffff.gif";
import API from "../../../../app/api";
import { Link } from "react-router-dom";
const PaymentCheck = () => {
  const [timeLeft, setTimeLeft] = useState(30); //  countdown state
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const orderId = searchParams.get("order_id");
  const transactionId = searchParams.get("transaction_id");
  const signature = searchParams.get("signature");
  useEffect(() => {
    document.title = "Obsessions - Payment Confirmation";
    if (!orderId || !transactionId) {
      navigate("/orderfailed", { replace: true });
      return;
    }
    let timeoutId;
    const verifyPayment = async () => {
      try {
        const { data } = await API.get("/checkout/payments/callback", {
          params: {
            payment_id: transactionId,
            order_id: orderId,
            signature: signature
          },
        });
        setLoading(false);
        timeoutId = setTimeout(() => {
          if (data?.success) {
            navigate(`/checkout/${data?.data?.secure_token || data?.data?.order_no}/order-confirmed`, {
              replace: true,
              state: { verifyResponse: data },
            });

          } else {
            navigate("/orderfailed", { replace: true });
          }
        }, 3000);
      } catch (error) {
        setLoading(false);
        timeoutId = setTimeout(() => {
          navigate("/orderfailed", { replace: true });
        }, 3000);
      }
    };
    verifyPayment();
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [orderId, transactionId, navigate]);

  // Countdown logic
  useEffect(() => {
    if (timeLeft === 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
      <div className="rounded-2xl p-8 text-center w-full max-w-md bg-white shadow-md">
        <div className="flex justify-center" style={{ marginBottom: "0" }}>
          <img
            src={processvideo}
            alt="Processing payment"
            className="w-24 h-24 object-contain"
          />
        </div>

        <h3 style={{ marginTop: "-35px" }}> <b style={{ color: " rgb(228, 66, 17)", fontSize: "22px" }}> We are processing your transaction </b> </h3>
        <p style={{ fontSize: "18px" }}> Don Not Refresh this page. Your transaction may take up to <span
          style={{
            fontWeight: "bold",
            color: "#000",
          }}
        >
          {timeLeft}
        </span>{" "} seconds to process </p>
        <Link href="/" style={{ fontfamily: "verdana, arial, helvetica, sans-serif", color: "rgb(0, 75, 145)", fontWeight: "bold", fontSize: "18px" }}>Click here to go back to the Obsessions home page </Link>

      </div>
    </div>
  );
};
export default PaymentCheck;